/**
 * A general purpose Key type to represent non-human-readable text (something unlikely to render).
 */
export default class Key {
  constructor(public value: string) {}

  public isKey = true as const;

  public toString = (): string => {
    return this.value;
  };

  public static fromString(value: string): Key {
    return new Key(value);
  }
}
